<template>
    <div class="projects-wrapper">
        <div class="invisible-image-loader" style="height: 0; width: 0;">
            <transition-group name="switch" mode="out-in">
                <div v-for="image in imageLoader" :key="image.id">
                    <img :src="image" />
                </div>
            </transition-group>
        </div>

        <div class="cover">
            <div class="cover__mask" @click="goToActiveProject">
                <transition name="switch" mode="out-in">
                    <img :src="this.activeImage" :key="this.activeImage" rel="preload" />
                </transition>
            </div>
            <div class="cover__image" :style="`--primaryColor: ${this.activePrimaryColor}; --secondaryColor: ${this.activeSecondaryColor}`" @click="goToActiveProject">
                <transition name="switch" mode="out-in">
                    <img :src="this.activeImage" :key="this.activeImage" rel="preload" /> 
                </transition>
            </div>
        </div>


        <div class="projects">
            <div v-for="project in projects" :key="project.id" class="projects__entity"
                @mouseover="handleProjectSelection($event, project, 'enter')"
                @click="goToProject(project)">
                <div class="entity__headline">
                    <router-link :to="project.data.link">
                        {{ project.data.title }}
                    </router-link>
                </div>
                <div class="entity__subheadline">
                    <div class="subheadline__animated">
                        {{ project.data.subtitle }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                activeImage: '../../assets/img/testtexture.png',
                activePrimaryColor: String,
                activeSecondaryColor: String,
                imageLoader: [],
                // activeImage: '',
                projects: [],
                activeProjectLink: null,
                lastSelected: null
            }
        },
        created() {
            this.getProjects();
        },
        methods: {
            getProjects() {
                this.$prismic.client.query(
                        this.$prismic.Predicates.at('document.type', 'projects'),
                    )
                    .then((document) => {
                        let projects = document.results
                    
                        // Filter the projects where project.release is 'portfolio-2023'
                        const filteredProjects = projects.filter(project => project.data.release === 'portfolio-2023');

                        // Sort the projects by their id
                        const sortedProjects = filteredProjects.sort((a, b) => {
                            return a.data.id - b.data.id;
                        });


                        this.projects = sortedProjects  

                        projects.forEach((project) => {
                            const imageURL = project.data.preview[0].preview1.url
                            this.imageLoader.push(imageURL)
                        })

                        console.log(this.imageLoader)
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },
            handleProjectSelection(event, project, status) {
                let selectedElement;
                let mask = this.$el.querySelector('.cover__mask');
                let image = this.$el.querySelector('.cover__image');


                if (event.target.className == 'entity__headline') {
                    if (event.target.parentElement.classList.contains('active')) {
                        return;
                    }
                    selectedElement = event.target.parentElement
                }

                if (event.target.className == 'projects__entity') {
                    if (event.target.classList.contains('active')) {
                        return;
                    }
                    selectedElement = event.target
                }

                this.lastSelected = event.target.className;

                if (typeof selectedElement === 'undefined') {
                    return;
                }

                if (status == 'leave') {
                    // console.log(event.target)
                }

                // Wipe all active classes from other children
                if (status == 'enter') {
                    let parent = selectedElement.parentNode;
                    parent.childNodes.forEach(child => {
                        child.classList.remove('active')
                    });
                }

                // Set the currently selected Element to active
                if (status == 'enter') {
                    this.activeImage = project.data.preview[0].preview1.url
                    this.activePrimaryColor = project.data.primarycolor
                    this.activeSecondaryColor = project.data.secondarycolor
                    this.activeProjectLink = project.data.link

                    console.log(this.activePrimaryColor)

                    selectedElement.classList.add('active')
                    mask.style.opacity = "0"
                    mask.classList.remove('animation')
                    image.classList.remove('animation')

                    setTimeout(() => {
                        mask.style.opacity = "1"
                        mask.classList.add('animation')
                        image.classList.add('animation')
                    }, 1)
                }
            },
            goToProject(project) {
                if (project && project.data && project.data.link) {
                    this.$router.push(project.data.link)
                }
            },
            goToActiveProject() {
                if (this.activeProjectLink) {
                    this.$router.push(this.activeProjectLink)
                }
            }
        }
    }
</script>


<style lang="scss" scoped>
    @import '../../assets/scss/base.scss';

    .projects-wrapper {
        display: flex;
        height: 100vh;
        align-items: center;
    }

    .cover {
        $border: 8px;
        $cover-height: 50rem;
        $cover-width: 80rem;
        height: 100%;
        width: 100%;
        position: absolute;
        background: $white-40;
        z-index: 1;
        display: flex;
        $animation-length: 1000ms;
        $initial-delay: 120ms;

        &__image {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translateX(-50%) translateY(-50%);
            width: $cover-width;
            height: $cover-height;
            max-width: calc(100vw - 20rem);
            max-height: calc(100vh - 12rem);
            opacity: 0;
            background-size: cover;
            z-index: 2;
            border-radius: 8px;
            background-clip: padding-box;
            cursor: pointer;
            /* !importanté */
            border: solid $border transparent;
            /* !importanté */
            border-radius: 12px;

            &:before {
                content: '';
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                z-index: -1;
                margin: -$border;
                /* !importanté */
                border-radius: inherit;
                /* !importanté */
                background: linear-gradient(to right, var(--primaryColor), var(--secondaryColor));
                transform: rotate(6deg); // transform: scaleY(1.07) scaleX(1.05);
            }

            img {
                object-fit: cover;
                height: 100%;
                width: 100%;
                border-radius: 8px;
            }

            &.animation {
                animation: 650ms reveal-cover-image $out-quart;
                animation-delay: 150ms;
                animation-iteration-count: 1;
                animation-fill-mode: forwards;
            }
        }

        &__mask {
            position: absolute;
            top: 50%;
            left: 50%;
            z-index: 1;
            border-radius: 12px;
            transform: translateX(-50%) translateY(-50%);
            width: $cover-width;
            height: $cover-height;
            max-width: calc(100vw - 20rem);
            max-height: calc(100vh - 12rem);
            overflow: visible;
            border: $border solid transparent;
            background-size: cover;
            cursor: pointer;

            // mask-image: url('../../assets/img/textures/animation-mask.svg');
            // mask-position: center center;
            // mask-repeat: no-repeat;
            img {
                object-fit: cover;
                height: 100%;
                width: 100%;
                filter: grayscale(0.66);
                border-radius: 12px;
            }

            &.animation {
                animation-iteration-count: 1;
                animation-fill-mode: forwards;
                animation: $animation-length reveal-mask-image $out-quart
            }
        }
    }



    .projects {
        display: flex;
        position: relative;
        flex-direction: column;
        width: 100%;
        max-width: 100rem;
        margin: 0 auto;
        z-index: 2;

        &__entity {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            font-family: "Franziska Italic";
            cursor: pointer;

            &.active {
                .entity__headline {
                    background: $white-100;

                    a {
                        font-size: 2.25rem;
                        color: black;
                        text-decoration: none;
                    }
                }

                .entity__subheadline {
                    display: block;
                    clip-path: inset(0 0 0 0);

                    background: rgba(0,0,0,.2);
                    backdrop-filter: blur(16px);
                    border-radius: 4px;
                    border: 0.5px solid rgba(0,0,0,.15);
                    padding: 0.25rem 0.5rem 0.5rem 0.5rem;

                    .subheadline__animated {
                        animation: 650ms slide-up $out-quart;
                    }

                    &:after {
                        content: '';
                        position: relative;
                        display: block;
                        width: 10rem;
                        height: 1px;
                        background: $white-100;
                        animation: 450ms line-reveal $out-quart;
                        animation-delay: 150ms;
                        animation-iteration-count: 1;
                        animation-fill-mode: forwards;
                        clip-path: inset(0 100% 0 0);
                    }
                }
            }
        }

        .entity {
            cursor: pointer;

            &__headline {
                padding: .5rem 1rem .22rem .75rem;
                margin: .5rem 0;

                a {
                    font-size: 2.25rem;
                    color: white;
                    text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
                    text-decoration: none;
                }
            }

            &__subheadline {
                display: none;
                color: white;
                text-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
                padding: .5rem 1rem .22rem .75rem;
            }
        }
    }
</style>